import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'
import { injectIntl, FormattedMessage } from 'react-intl'

import HUBContext from '../services/HUBContext'
import { FolderIcon } from '../common/icons'

const styles = theme => ({
})

export class NoData extends Component {
    render() {
        const { message, submessage } = this.props

        return <div className='no-data'>
            <span><FolderIcon/></span>
            <h5>{ message || <FormattedMessage id='nodata' defaultMessage='No data to display' /> }</h5>
            { !!submessage && <p className='no-data-submessage'>{ submessage || 'Pruebas subtext' }</p>}
        </div>
    }
}

NoData.contextType = HUBContext

export default withStyles(styles)(injectIntl(NoData))